module.exports = __webpack_public_path__ + "static/media/flowersPotDec.122326b3.png";